<template>
  <div class="component-container">
    <label v-if="showLabel()" :style="lableStyle"
      ><span class="xing" :style="required ? { color: '#f00' } : null">*</span
      >{{ label }}</label
    >
    <div :style="imgstyle">
      <div v-if="showImage()" class="image-container" :style="imageFrameStyle">
        <img @load="adjustImageStyle" :src="src" :style="imageStyle" />
        <div class="image-mask">
          <el-tooltip :content="tooltipForPreview" placement="top-start">
            <i
              class="el-icon-zoom-in el-icon-action"
              @click.prevent="handlePreview(src)"
            />
          </el-tooltip>
          <el-tooltip
            :content="tooltipForDelete"
            placement="top-start"
            v-if="isedite"
          >
            <i
              class="el-icon-delete el-icon-action"
              @click.prevent="handleDelete"
            />
          </el-tooltip>
        </div>
      </div>
      <div v-else class="image-upload">
        <el-tooltip
          popper-class="image-tip"
          :disabled="disabledTooltip() || !isedite"
          :content="tooltip"
          placement="top-start"
          :hide-after="5000"
          v-if="types== 'image'"
        >
          <el-upload
            class="upload-btn"
            :style="uploadStyle"
            :disabled="!isedite"
            :action="uploadAction"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :before-upload="handleBeforeUpload"
            accept="image/*"
            :on-change="handlechange"
           
          >
            <div class="icon-wrap-container" :style="uploadStyle" >
              <i class="el-icon-loading uploader-icon" v-if="imgloading" />
              <i class="el-icon-plus uploader-icon" v-else />
            </div>
          </el-upload>
        </el-tooltip>
      </div>
      <div class="imgtips" v-if="tipimg">
        <img
          :src="tipimg"
          :style="tipsimageStyle"
          @click.prevent="handlePreview(tipimg)"
        />
      </div>
      <el-dialog :visible.sync="preview" :show-close="false" :top="'5vh'">
        <img width="100%" :src="showimg" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Validator from '../../utils/validator'
import { Notification } from 'element-ui'

export default {
  name: 'jtImage',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelWidth: {
      type: String,
      default: '30%',
    },
    src: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    thumbnailWidth: {
      type: String,
      default: '100px',
    },
    thumbnailHeight: {
      type: String,
      default: '100px',
    },
    uploadAction: {
      type: String,
      required: true,
    },
    supportTypes: {
      type: Array,
      default: () => ['image/jpeg', 'image/png', 'image/jpg'],
    },
    supportSize: {
      type: Array,
      default: [5],
    },
    supportMinWidth: {
      type: Number,
      default: 0,
    },
    supportMaxWidth: {
      type: Number,
      default: 1920,
    },
    supportMinHeight: {
      type: Number,
      default: 0,
    },
    supportMaxHeight: {
      type: Number,
      default: 1080,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    scaleWH: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    alwaysEdit: {
      type: Boolean,
      default: false,
    },
    types: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      lableStyle: {
        width: window.innerWidth > 768 ? this.labelWidth : '100%',
      },
      imgstyle: {
        width: window.innerWidth > 768 ? '500px' : '100%',
      },
      imageFrameStyle: {
        width: this.thumbnailWidth,
        height: this.thumbnailHeight,
      },
      imageStyle: {
        width: this.thumbnailWidth,
        height: this.thumbnailHeight,
      },
      tipsimageStyle: {
        width: this.thumbnailWidth,
        height: this.thumbnailHeight,
      },
      uploadStyle: {
        width: this.thumbnailWidth,
        height: this.thumbnailHeight,
      },
      thumbnailSrc: '',
      tooltipForPreview: this.$t('image.TOOLTIP_FOR_PREVIEW'),
      tooltipForDelete: this.$t('image.TOOLTIP_FOR_DELETE'),
      preview: false,
      tipimg: null,
      showimg: '',
      scale: '',
      imgloading: false,
    }
  },
  computed: {
    isedite() {
      if (this.alwaysEdit) {
        return true
      } else {
        return this.editable
      }
    },

    
  },
  methods: {
    handelscaleWH() {
      if (this.scaleWH) {
        if (this.scaleWH.indexOf('imgtips') !== -1) {
          let arr = this.scaleWH.split('imgtips')
          if (arr[0]) {
            this.scale = arr[0]
          }
          this.tipimg = require('../../assets/imgtips' + arr[1] + '.jpg')
        } else {
          this.scale = this.scaleWH
        }
      }
    },
    showLabel() {
      return !_.isEmpty(_.trim(this.label))
    },
    showImage() {
      return !_.isEmpty(this.src)
    },
    disabledTooltip() {
      return _.isEmpty(_.trim(this.tooltip))
    },
    adjustImageStyle() {
      const img = new Image()
      img.onload = () => {
        if (img.width >= img.height) {
          this.imageStyle = { width: this.thumbnailWidth }
        } else {
          this.imageStyle = { height: this.thumbnailHeight }
        }
      }
      img.src = this.src
    },
    handlePreview(src) {
      this.preview = true
      this.showimg = src
    },
    handleDelete() {
      const msg = this.$t('image.CONFIRM_FOR_DELETE')
      const title = this.$t('global.TIPS')
      this.$confirm(msg, title, {
        confirmButtonText: this.$t('page.SUBMIT_CONFIRM_OK'),
        cancelButtonText: this.$t('page.SUBMIT_CONFIRM_CANCEL'),
      })
        .then(() => {
          this.imgloading = false
          this.$emit('delete')
        })
        .catch(() => {})
    },
    handleUploadSuccess(response, file, fileList) {
      this.imgloading = false
      this.$emit('success', response.payload)
    },
    handleUploadError(err, file, fileList) {
      let { errMsg } = JSON.parse(err.message)
      this.imgloading = false
      Notification.error({
        title: 'Error',
        message: '图片上传失败，请检查图片格式并更换图片',
        duration: 5000,
        showClose: true,
      })
      throw errMsg
    },

    handleBeforeUpload(file) {
      if (this.scale) {
        return false
      } else {
        try {
          this._validate(file)
          return true
        } catch (err) {
          const title = this.$t('global.ERROR')
          this.$alert(err.message, title, {
            type: 'error',
            showClose: false,
          })

          throw err
        }
      }
    },
    async handlechange(file) {
      this.imgloading = true
      if (this.scale) {
        try {
          await this._validate(file.raw)
          this.$emit('change', file.raw, this.uploadAction, this.scale)
          this.imgloading = false
        } catch (err) {
          const title = this.$t('global.ERROR')
          await this.$alert(err.message, title, {
            type: 'error',
            showClose: false,
          })
          this.imgloading = false
          throw err
        }
      }
    },
    async _validate(file) {
      let errMsg = this.$t('image.SUPPORT_IMAGE_TYPE', {
        imgType: _.join(this.supportTypes),
      })
      Validator.isSupportFileType(file.type, this.supportTypes, errMsg)

      let errMsg1 = this.$t('image.SUPPORT_IMAGE_SIZE', {
        imgSize:
          this.supportSize.length === 2
            ? this.supportSize[1] / 1024 / 1024
            : this.supportSize[0] / 1024 / 1024,
      })
      let errMsg2 = this.$t('image.MIN_IMAGE_SIZE', {
        imgSize: this.supportSize[0] / 1024 / 1024,
      })
      Validator.isSupportFileSize(file.size, this.supportSize, errMsg1, errMsg2)

      const { width, height } = await this._getImageWidthAndHeight(file)

      const {
        supportMinWidth,
        supportMaxWidth,
        supportMinHeight,
        supportMaxHeight,
      } = this

      errMsg = this.$t('image.SUPPORT_IMAGE_WIDTH_AND_HEIGHT', {
        supportMinWidth,
        supportMaxWidth,
        supportMinHeight,
        supportMaxHeight,
      })
      Validator.isSupportImageSize(
        { width, height },
        {
          supportMinWidth,
          supportMaxWidth,
          supportMinHeight,
          supportMaxHeight,
        },
        errMsg
      )
    },
    _getImageWidthAndHeight(file) {
      return new Promise((resolve, reject) => {
        const image = new Image()
        image.onload = () => {
          const { width, height } = image
          resolve({
            width,
            height,
          })
        }
        image.src = URL.createObjectURL(file)
      })
    },
  },

  mounted() {
    this.handelscaleWH()
  },
}
</script>

<style lang="stylus" scoped>
.component-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.image-container {
  float: left;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  // text-align center
  // border 1px dashed #333
  // padding 5px
}

.image-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
}

.image-mask:hover {
  opacity: 1;
}

.el-icon-action {
  font-size: 28px;
  color: white;
  margin-left: 5px;
  cursor: pointer;
}

.component-container >>> .el-dialog__header, .component-container >>> .el-dialog__body {
  padding: 0;
}

.upload-btn {
  border: 1px dashed #333;
}

.icon-wrap-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.uploader-icon {
  font-size: 28px;
  color: #333;
  cursor: pointer;
}

.image-upload {
  float: left;
}

.image-tip {
  max-width: 200px;
}

.imgtips {
  float: left;
  margin-left: 30px;
}

.component-container >>> .el-dialog {
  max-width: 420px;
}
</style>
